import script from "./ProfileRegionDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileRegionDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileRegionDrawer.vue?vue&type=style&index=0&id=2409ad1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2409ad1e"]])

export default __exports__